import { Component } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';

import { ACTIVATEACCOUNTLABELS } from '../_constants/constants';
import { CustomerService } from '../_services/customer.service';

export interface ActivateAccountDialogModel {
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
}

@Component({
    templateUrl: 'activate.account.dialog.component.html'
})

export class ActivateAccountDialogComponent extends DialogComponent<ActivateAccountDialogModel, string> implements ActivateAccountDialogModel {
  
    customerService: CustomerService;
    subValue: string;
    opcoValue: string;
    activateaccountlabels = ACTIVATEACCOUNTLABELS;

    constructor(private ds: DialogService) {
          super(ds);
    }

    activateAccountRequest() {
        if(this.opcoValue === 'ro'){
            this.customerService.activateAccountRequest(this.subValue, this.opcoValue, this.ds);
        }
        this.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/activateaccount/activate.account.dialog.component.ts